import type { Lap } from '../../domain/lap/Lap'
import type { ZoneAnalysisResult } from '../zones/TrackZoneTypes'
import { detectSessionZones, filterExcludedLaps } from './analyzeSession'
import { computeAutoExcludedLapIds } from './lapOutlierExclusion'

export interface DefaultSessionView {
  excludedLapIds: Set<string>
  analysis: ZoneAnalysisResult
}

export function defaultSessionView(laps: Lap[]): DefaultSessionView {
  const excludedLapIds = computeAutoExcludedLapIds(
    laps.map((lap) => ({ lapId: lap.id, lapTimeMs: lap.lapTime }))
  )
  const analysis = detectSessionZones(
    filterExcludedLaps(laps, excludedLapIds),
    laps,
    undefined,
    excludedLapIds
  )
  return { excludedLapIds, analysis }
}
